import { CDN_LINK } from "@globalConfig";
import AsideTag from "../AsideTags/AsideTag/AsideTag";

import stl from "./SubFilterOpenButton.module.css";

function SubFilterOpenButton({
  name,
  onClick,
  count,
  isLoading,
  disabled,
  isRange,
  handleDeleteFilters,
  option,
}) {
  return (
    <>
      <div
        className={`${stl.container} ${isLoading ? stl.isLoading : ""} ${
          disabled ? stl.disabled : ""
        }`}
        onClick={onClick}
      >
        <strong>{name}</strong>
        {count && !isRange && <span className={stl.seletedItems}>{count}</span>}
        {count && isRange && (
          <AsideTag
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteFilters(option);
            }}
            name={`${option.range_values.from} - ${option.range_values.to} ${option.range_values.unit}`}
            className={stl.rangeTag}
            textellipsis
          />
        )}
        {isLoading ? (
          <div className={stl.fixedLoaderContainer}>
            <img
              className={stl.loaderContainer}
              src={CDN_LINK + "/assets/images/FilterLoader.svg"}
              alt="loading"
            />
          </div>
        ) : !disabled ? (
          <img
            src={CDN_LINK + "/assets/images/arrAcc.svg"}
            alt="arrow"
            width={"12px"}
            height={"7px"}
          />
        ) : null}
      </div>
    </>
  );
}

export default SubFilterOpenButton;
